import Modals from 'components/modals/modals';
import { browserHistory } from 'config/historyNavigate';
import { queryClient } from 'config/react-query';
import useCoreDataHandlers from 'core/useCoreDataHandlers.hook';
import { QueryClientProvider, ReactQueryDevtools } from 'core/utils/data-store/tools';
import Infra from 'infra/infra.container';
import type React from 'react';
import type { HistoryRouterProps } from 'react-router-dom';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';

const toggleButtonRenderProps: React.ButtonHTMLAttributes<HTMLButtonElement> = {
  style: {
    marginBottom: '70px'
  }
};

const AppChildren = () => {
  useCoreDataHandlers();
  return (
    <>
      <Infra />
      <Modals />
    </>
  );
};

const App = () => {
  const historyObject = { history: browserHistory } as unknown as HistoryRouterProps;

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} toggleButtonProps={toggleButtonRenderProps} />
      <HistoryRouter history={historyObject.history}>
        <AppChildren />
      </HistoryRouter>
    </QueryClientProvider>
  );
};

export default App;
